import { call } from 'redux-saga/effects';

import * as pageInitializerService from '../page.initializer.saga-service';
import * as pageStateService from '../page-state/page-state.saga-services';
import * as companyToolsCategoriesPageService from '../page-storage/company-tools-categories/company-tools-categories.saga-services';

export function* initialAgencyToolsPage() {
  yield call(pageStateService.initPage, 'agencyTools');

  if (!((yield call(pageInitializerService.initPage)) as boolean)) {
    yield call(companyToolsCategoriesPageService.setupCompanyToolsCategories);
  }
  yield call(pageStateService.completedInit, 'agencyTools');
}
